<div id="inspector-video-wrapper">
    <div id="inspector-video-splash-screen">
        Wait for connection
    </div>
    <div class="inspector-video" hidden="true">
        <img src="assets/icons/video-record-icon.png" id="video-record-icon" hidden = "true"/>
        <img src="assets/icons/nq-4.png" id="inspector-network-quality" />
    </div>
</div>